// material
import { useCallback, useEffect, useState } from "react";
import { Container, Button } from "@mui/material";
import Grid from "@mui/material/Grid";
// components
import Page from "../components/Page";
import Translate from "../utils/Translate";
import CircularCourses, { CircularCoursesProvider } from "../components/_dashboard/app/CircularCourses";
import CoursesOverTime from "../components/_dashboard/app/CoursesOverTime";
import PasswordBalance from "../components/_dashboard/app/PasswordBalance";
import UsersMonth from "../components/_dashboard/app/UsersMonth";
import OverallStats from "../components/_dashboard/app/OverallStats";
import Order from "../components/_dashboard/app/Order";
import Download from "../components/_dashboard/app/Download";
import BuyLic from "../components/_dashboard/app/BuyLic";
import { useApi } from "../utils/Api";
import Preloader from "../components/Preloader";
import SchoolIcon from "@mui/icons-material/School";
import PeopleIcon from "@mui/icons-material/People";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import SpeedMenu from "../components/SpeedMenu";
import AddIcon from "@mui/icons-material/Add";
import CourseDialog from "../components/courses/CourseDialog";
import DomainIcon from "@mui/icons-material/Domain";
import { accessKeys, hasSomeAccess } from "../utils/userAccess";

import NoticeBox from "../components/_dashboard/app/NoticeBox";
import ButtonWithSpinner from "../components/ButtonWithSpinner";
const getSpeedMenu = (props) => {
  //console.log(props)
  const menudata = [
    {
      icon: <AddIcon />,
      text: Translate.get("AddCourse"),
      route: false,
      dialogHeader: Translate.get("AddCourse"),
      customClass: "bigCourseDialog",
      component: <CourseDialog {...props} />,
      //disabled: props.freeRoll,
    },
    /*  {
       icon: <AddIcon />,
       text: "Testa e-kurs",
       route: false,
       dialogHeader: "Testa e-kurs",
       customClass: "smallCourseDialog",
       component: <TryOutCourse />,
       hide: !props.freeRoll,
 
     }, */
  ];
  return menudata;
};

// ----------------------------------------------------------------------
//Mock data start

const fixStats = (data) => {
  //Check if the user have no courses and no licenses, if so, show different dashboard
  ////console.log('data.actorStatistics.totalNumberOfCourses', data.actorStatistics.totalNumberOfCourses)
  ////console.log('data.eLearningLicenseBalance.length', data.eLearningLicenseBalance)
  let freeRoll = false;
  if (
    data.actorStatistics.totalNumberOfCourses === 0 &&
    data.eLearningLicenseBalance.filter((x) => x.numberOfFreeLicenses > 0).length === 0
  ) {
    freeRoll = true;
  }
  //-----
  //data.courseDistribution=data.courseDistribution.slice(0,10);
  //data.courseParticipantDistribution=data.courseParticipantDistribution.slice(0,10);
  const loopGraph = (data) => {
    const series = [];
    const finalSeries = [];
    let dateLabel = "";

    for (const row of data) {
      dateLabel = `${row.month.toString().padStart(2, "0")}/10/${row.year}`;
      if (!series[row.description]) {
        series[row.description] = {
          name: row.description,
          color: row.webColor,
          data: [],
        };
      }
      series[row.description].data.push({
        x: dateLabel,
        y: row.participants ?? row.count,
      });
    }

    for (const [, row] of Object.entries(series)) {
      finalSeries.push({
        name: row.name,
        color: row.color,
        data: row.data,
      });
    }
    return finalSeries;
  };
  let passWordBalance = [];
  const overAllStats = {
    courseParticipantsTotal: data.actorStatistics.totalNumberOfStudents,
    coursesTotal: data.actorStatistics.totalNumberOfCourses,
    numberOfCompanies: data.actorStatistics.numberOfCompanies,
  };

  for (const row of data.eLearningLicenseBalance) {
    passWordBalance.push({
      name: Translate.getELearningType(row.eLearningType),
      value: row.numberOfFreeLicenses,
      color: row.webColor,
    });
  }

  const coursesOverTime = {};
  coursesOverTime.labels = [];
  coursesOverTime.series = [];
  const userMonth = {};
  userMonth.labels = [];
  userMonth.series = [];

  coursesOverTime.series = loopGraph(data.courseDistribution);
  userMonth.series = loopGraph(data.courseParticipantDistribution);

  return {
    passWordBalance: passWordBalance,
    coursesOverTime: coursesOverTime,
    userMonth: userMonth,
    overAllStats: overAllStats,
    freeRoll: freeRoll,
  };
};

export default function DashboardApp() {
  const [courseInfo, setCourseInfo] = useState(false);
  const [isInitDone, setIsInitDone] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [lockFw, setLockFw] = useState(true);
  const [lockBw, setLockBw] = useState(false);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(0);
  const [baseStats, setBaseStats] = useState(false);
  // nyheter visas inte just nu
  //const [newsFeed, setNewsFeed] = useState(null);
  const [elements, setElements] = useState(null);
  const [window, setWindow] = useState(null);
  const api = useApi();

  const loadBaseStats = useCallback(async () => {
    const result = await api.fetch(`${import.meta.env.VITE_MAIN_URL}dashboard/`, false, "GET");
    if (result.isSuccessful) {
      setBaseStats(fixStats(result));
    } else {
      setBaseStats({
        passWordBalance: [],
        coursesOverTime: { labels: [], series: [] },
        userMonth: { labels: [], series: [] },
        overAllStats: {
          courseParticipantsTotal: "0",
          coursesTotal: "0",
          totalNumberOfLicenses: "0",
          numberOfCompanies: "0",
        },
      });
    }
  }, [api]);

  const loadCourses = useCallback(
    async (startIndex, endIndex, getMostCurrentPage = false) => {
      setLockBw(false);
      setLockFw(false);
      const req = {
        GetMostCurrentWindow: getMostCurrentPage,
        Window: { StartIndex: startIndex, EndIndex: endIndex },
      };
      const result = await api.fetch(`${import.meta.env.VITE_MAIN_URL}dashboard/current-courses/`, req);
      if (result.isSuccessful) {
        setWindow(result.window);
        setElements(result.elements);
        setStartIndex(result.window.startIndex);
        setEndIndex(result.window.endIndex);
        if (result.window.startIndex - 1 < 0) {
          setLockBw(true);
        }
        if (result.window.endIndex + 1 >= result.elements) {
          setLockFw(true);
        }
        setCourseInfo(result.courses);
      }
    },
    [api],
  );

  //nyheter visas inte nu
  // const fetchNews = () => {
  //   api.fetch(`${import.meta.env.VITE_MAIN_URL}dashboard/news/`).then(
  //     (data) => {
  //       if (data && data.length) {
  //         setNewsFeed(data.slice(0, 5));
  //       }
  //     }
  //   );
  // };

  useEffect(() => {
    async function init() {
      setIsLoading(true);
      await Promise.all([loadBaseStats(), loadCourses(startIndex, endIndex, true)]);
      //nyheter visas inte nu
      //fetchNews();
      setIsLoading(false);
    }
    if (!isInitDone) {
      setIsInitDone(true);
      init();
    }
  }, [isInitDone, startIndex, endIndex, loadBaseStats, loadCourses]);

  async function loadMoreCourses(direction) {
    let newStartIndex;
    let newEndIndex;
    if (direction === "prev") {
      //Hämta tre tidigare
      newStartIndex = Math.max(startIndex - 3, 0);
      newEndIndex = newStartIndex + 2;
    } else {
      //Hämta tre senare
      newStartIndex = endIndex + 1;
      newEndIndex = Math.min(newStartIndex + 2, elements);
    }
    await loadCourses(newStartIndex, newEndIndex);
  }

  if (isLoading || !isInitDone) {
    return <Preloader invisible={true} />;
  }

  return (
    <>
      <Page>
        <Container
          //maxWidth="xl"
          maxWidth={false}
          className="dashboard"
          disableGutters={true}
        >
          <Grid container spacing={3} sx={{ alignItems: "flex-start" }}>
            {!baseStats.freeRoll && (
              <Grid container spacing={3} size={{ xs: 12, lg: 9 }}>
                <Grid size={12}>
                  <h2>
                    {Translate.get("Courses")}
                    <Button sx={{ marginLeft: "16px", padding: "2px 8px" }} href={`/dashboard/courses/`}>
                      {Translate.get("ShowAll")}
                    </Button>
                  </h2>
                </Grid>
                <Grid container size={12} spacing={0}>
                  <CircularCoursesProvider>
                    <Grid container size={12} spacing={3}>
                      <Grid className="hideEmpty" size={{ xs: 12, sm: 6, md: 6, xl: 4 }}>
                        <CircularCourses data={courseInfo[0]} />
                      </Grid>
                      <Grid className="hideEmpty" size={{ xs: 12, sm: 6, md: 6, xl: 4 }}>
                        <CircularCourses data={courseInfo[1]} />
                      </Grid>
                      <Grid className="hideEmpty" size={{ xs: 12, sm: 6, md: 6, xl: 4 }}>
                        <CircularCourses data={courseInfo[2]} />
                      </Grid>
                    </Grid>
                  </CircularCoursesProvider>
                  <Grid className="stdFlexRow gridNoTopSpace" size={12}>
                    <ButtonWithSpinner
                      disabled={lockBw}
                      startIcon={<NavigateBeforeIcon />}
                      onClick={async () => await loadMoreCourses("prev")}
                    >
                      {Translate.get("EarlierCourseInstances")}
                    </ButtonWithSpinner>
                    <ButtonWithSpinner
                      disabled={lockFw}
                      endIcon={<NavigateNextIcon />}
                      onClick={async () => await loadMoreCourses("next")}
                    >
                      {Translate.get("LaterCourseInstances")}
                    </ButtonWithSpinner>
                  </Grid>
                </Grid>

                <Grid size={12}>
                  <h2>{Translate.get("Statistics")}</h2>
                </Grid>
                {/*  <Grid size={{ xs: 12, sm: 12, md: 12, xl: 4 }}>
                    <PasswordBalance data={baseStats.passWordBalance} />
                  </Grid> */}
                <Grid size={{ xs: 12, sm: 12, md: 12, xl: 12 }}>
                  <CoursesOverTime data={baseStats.coursesOverTime} />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12, xl: 12 }}>
                  <UsersMonth data={baseStats.userMonth} />
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, xl: 4 }}>
                  <OverallStats
                    icon={<PeopleIcon />}
                    value={baseStats.overAllStats.courseParticipantsTotal}
                    text={Translate.get("CourseParticipantsTotal")}
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, xl: 4 }}>
                  <OverallStats
                    icon={<SchoolIcon />}
                    value={baseStats.overAllStats.coursesTotal}
                    text={Translate.get("CoursesTotal")}
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, xl: 4 }}>
                  <OverallStats
                    icon={<DomainIcon />}
                    value={baseStats.overAllStats.numberOfCompanies}
                    text={Translate.get("CompaniesTotal")}
                    //text={Translate.get('TotalNumberOfLicenses')}
                  />
                </Grid>
              </Grid>
            )}
            {baseStats.freeRoll && (
              <Grid container spacing={3} size={{ xs: 12, lg: 9 }}>
                <Grid size={12}>
                  <h2>{Translate.get("OngoingCourse")}</h2>
                </Grid>
                <Grid size={12}>
                  <div className="dashedBoxCenter">
                    <img src="/static/icons/no-data-e-course.svg" />
                    <h2>{Translate.get("NoCoursesAvailiable")}</h2>
                    {Translate.get("FreeTryStateText")}
                    {/*  Skapa din första e-kurs genom att trycka på plustecknet nere till höger.<br />
                      Vi bjuder på det första lösenordet! */}
                  </div>
                </Grid>
                <Grid size={12}>
                  <h2>{Translate.get("Statistics")}</h2>
                </Grid>
                <Grid size={12}>
                  <div className="dashedBoxCenter">
                    <img src="/static/icons/no-statistics.svg" />
                    <h2>{Translate.get("NoStatsNow")}</h2>
                    {Translate.get("EmptyStats")}
                  </div>
                </Grid>
              </Grid>
            )}
            <Grid container spacing={3} direction="column" size={{ xs: 12, lg: 3 }}>
              <Grid>
                <h2>{Translate.get("InstructorServices")}</h2>
              </Grid>
              {!hasSomeAccess(accessKeys.standardPackage, accessKeys.advancedPackage) && (
                <Grid>
                  <Order />
                </Grid>
              )}

              <Grid>
                <Download />
              </Grid>

              <Grid>
                <BuyLic />
              </Grid>
              {/*    {!baseStats.freeRoll && (
                <>
                  <Grid >
                    <h2>{Translate.get("NewsFeed")}</h2>
                  </Grid>
                  <Grid >
                    <News data={newsFeed} />
                  </Grid>
                </>
              )} */}
              <>
                <Grid>
                  <h2>Resurser</h2>
                </Grid>
                <Grid>
                  <PasswordBalance data={baseStats.passWordBalance} />
                </Grid>
              </>
            </Grid>
          </Grid>
        </Container>
      </Page>
      <SpeedMenu
        content={getSpeedMenu({
          id: 0,
          freeRoll: baseStats.freeRoll,
        })}
      />
    </>
  );
}
